import { render, staticRenderFns } from "./StorageSpaceDelete.vue?vue&type=template&id=2fffdff3&"
import script from "./StorageSpaceDelete.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports